import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { CompanyResource } from '../../resources/company.resource';
import { CompanyService } from '../../../services/company.service';
import { IFBCompanyRegistrationPageBranding } from '@interfaces';

@Injectable({
  providedIn: 'root'
})
export class BackgroundBrandedService {
  constructor(
    private companyResource: CompanyResource,
    private companyService: CompanyService
  ) {}

  public fetchBranding(): Observable<IFBCompanyRegistrationPageBranding> {
    const branding = this.companyService.data.registrationPageBranding;

    if (branding?.backgroundImage?.id) {
      return of(branding);
    }

    return this.companyResource.getRegistrationPageBranding().pipe(
      tap(response => {
        this.companyService.set({
          registrationPageBranding: response
        });
      })
    );
  }
}
